import { CustomElementClass } from './element';
if (!customElements.get('fw-button-wrapper')) {
    customElements.define('fw-button-wrapper', CustomElementClass);
}
